import { Button, CircularProgress } from "@mui/material";

export default function LoaderButton({
  isLoading = false,
  text,
  loadingText,
  variant = "contained",
  ...props
}) {
  return (
    <Button
      variant={variant}
      disabled={isLoading || props.disabled}
      startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
      {...props}
    >
      {isLoading ? loadingText ?? text : text}
    </Button>
  );
}
